<template>
  <div class="container-fluid">
    <div class="row">
      <div v-if="can('invoice_list')" class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Invoices</h5>
        </div>
        <div class="table-responsive">
        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">

            <template v-slot:total_amount="{ row }">
              <div>{{ formatPrice(row.total_amount) }}</div>
            </template>

          <template v-slot:action="{ row }">
            <a href="javascript:void(0)" class="btn btn-primary btn-sm me-1" @click="downloadCloudInvoicePDF(row.id)">
              Download
            </a>
            <a href="javascript:void(0)" class="btn btn-outline-primary btn-sm" @click="openPaymentHistoryModal(row.id)">
              Details
            </a>
          </template>
        </cloud-table-component>
        </div>
      </div>
      <div v-else>
        <p>You do not have permission to view this content.</p>
      </div>
    </div>

    <BaseModal
        v-if="isShowPaymentHistoryModal"
        title="Invoice Payment History"
        :closeModal="closePaymentHistoryModal"
        size="modal_1400p"
    >
      <InvoicePaymentHistory
          :invoiceid="selectedInvoiceId"
      />
    </BaseModal>

  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import { useAbility } from '@casl/vue';
import BaseModal from "@/components/BaseModal.vue";
import InvoicePaymentHistory from "@/views/billing/InvoicePaymentHistory.vue";

export default {
  name: "Invoices",
  components: {InvoicePaymentHistory, BaseModal, CloudTableComponent},
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
  data() {
    return {
      inquiries: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'invoice_number,invoice_date',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Invoice ID",
          field: "invoice_number",
        },
        {
          label: "Invoice Date",
          field: "invoice_date",
        },
        {
          label: "Month of Invoice",
          field: "month_of_invoice",
        },
        {
          label: "Total Amount",
          field: "total_amount",
          slot: true,
          sortable: false,
        },
        {
          label: "Payment Method",
          field: "paymentMethod.name",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Paid At",
          field: "paid_at",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
      isShowPaymentHistoryModal: false,
      selectedInvoiceId: null
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.getMyInquiry()
      }
    },
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.getMyInquiry()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'invoice_number,invoice_date',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    getMyInquiry() {
      this.lyLoading = true
      let params = { ...this.queryParams, ...this.filter }
      this.axios.get('/billing-invoices', {
        params : params
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    async downloadCloudInvoicePDF(invoiceId) {
      try {
        const response = await this.axios({
          url: `/download-billing-invoice/${invoiceId}`,
          method: 'GET',
          responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Vlan24 Cloud Invoice- ${new Date().toLocaleDateString()}.pdf`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error('There was an error downloading the PDF:', error);
      }
    },
    openPaymentHistoryModal(invoiceId){
      this.selectedInvoiceId = invoiceId
      this.isShowPaymentHistoryModal = true
    },
    closePaymentHistoryModal(){
      this.selectedInvoiceId = null
      this.isShowPaymentHistoryModal = false
    },
  }
}
</script>

<style scoped>

</style>